import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  styled,
} from '@mui/material';

import { QueryResultsFooter } from './queryResultsFooter';

const DBResultsTable = styled(Table)({
  whiteSpace: 'nowrap',
  height: 'max-content',
  backgroundColor: 'var(--mui-palette-background-secondary)',
});

const DBResultsRow = styled(TableRow)({
  height: '30px',
  maxHeight: '30px',
});

const DBResultsHeaderCell = styled('th')({
  textAlign: 'left',
  padding: '2px 15px',
  backgroundColor: 'var(--mui-palette-background-section)',
  fontWeight: 'normal',
});

const DBResultsCell = styled(TableCell)(function () {
  return {
    textAlign: 'left',
    padding: '2px 15px',
  };
});

export function QueryResultsTable(props: {
  queryId?: string;
  headerColumns?: string[];
  data?: string[][];
  executionTime?: number;
  resultsLink?: string | null;
  loading: boolean;
  error?: { msg?: string; code?: number } | null;
}) {
  return (
    <Box
      sx={{
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <Stack className='h-full'>
        <Box
          className='flex grow'
          sx={{
            overflow: 'auto',
            border: '1px solid var(--mui-palette-divider)',
            borderRadius: '16px',
          }}
        >
          <DBResultsTable data-testid='query-results-table'>
            {props.headerColumns && (
              <TableHead>
                <DBResultsRow>
                  {props.headerColumns.map((header, i) => (
                    <DBResultsHeaderCell
                      key={i}
                      sx={{
                        borderLeft:
                          i === 0
                            ? 'none'
                            : '1px solid var(--mui-palette-divider)',
                        borderRight:
                          i === (props.headerColumns?.length ?? 0) - 1
                            ? 'none'
                            : '1px solid var(--mui-palette-divider)',
                      }}
                    >
                      {header}
                    </DBResultsHeaderCell>
                  ))}
                </DBResultsRow>
              </TableHead>
            )}

            <TableBody>
              {props.data?.map((row, i) => (
                <DBResultsRow key={i}>
                  {row.map((cell, j) => (
                    <DBResultsCell
                      key={j}
                      sx={{
                        borderTop: '1px solid var(--mui-palette-divider)',
                        borderBottom:
                          i === (props.data?.length ?? 0) - 1
                            ? 'none'
                            : '1px solid var(--mui-palette-divider)',
                        borderLeft:
                          j === 0
                            ? 'none'
                            : '1px solid var(--mui-palette-divider)',
                        borderRight:
                          j === row.length - 1
                            ? 'none'
                            : '1px solid var(--mui-palette-divider)',
                      }}
                    >
                      {cell}
                    </DBResultsCell>
                  ))}
                </DBResultsRow>
              ))}
            </TableBody>
          </DBResultsTable>
        </Box>
        <QueryResultsFooter {...props} />
      </Stack>
    </Box>
  );
}
